import React from "react";
import { PageLayout } from "../components/page-layout";
import UserDomainsAdmin from "../components/UserDomainsAdmin";
import { useRoles } from "../components/useRoles";
import AdminPanel from "../components/AdminPanel";
import UserDomainsAdminOld from "../components/UserDomainsAdminOld";
import AdminReports from "../components/AdminReports";

export const AdminPage = () => {
  const { isAdmin, isLoading } = useRoles();

  if (isLoading) {
    return <div>Laster...</div>;
  }

  if (!isAdmin) {
    return (
      <PageLayout>
        <div className="content-layout">
          <h1 id="page-title" className="content__title">
            Ingen tilgang
          </h1>
          <div className="content__body">
            <p id="page-description">
              <span>Du har ikke tilgang til denne siden.</span>
            </p>
          </div>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <div className="content-layout">
        <h1 id="page-title" className="content__title">
          Administrasjon
        </h1>
        <div className="content__body">
          <p id="page-description">
            <span>Administrer domener, brukere og innstillinger.</span>
          </p>
          <UserDomainsAdmin />
          <UserDomainsAdminOld />
          <AdminPanel />
          <AdminReports />
        </div>
      </div>
    </PageLayout>
  );
};
